import { promptService } from './promptService';
import { schemaService } from './schemaService';
import { llmConfigService } from './llmConfigService';
import { ocrConfigService } from './ocrConfigService';
import type { Prompt, ExtractionSchema, LLMConfig, OCRConfig } from '../types';

export interface CatalogItem {
  id: string;
  domain: string;
  name: string;
  version: string;
}

const toItem = (x: { id: string; domain: string; name: string; version: string }): CatalogItem => ({
  id: x.id,
  domain: x.domain,
  name: x.name,
  version: x.version,
});

export const catalogService = {
  async listPrompts(opts?: { domain?: string }): Promise<Prompt[]> {
    return promptService.list(opts?.domain ? { domain: opts.domain } : undefined);
  },

  async listSchemas(opts?: { domain?: string }): Promise<ExtractionSchema[]> {
    return schemaService.list(opts?.domain ? { domain: opts.domain } : undefined);
  },

  async listOcrConfigs(opts?: { domain?: string }): Promise<OCRConfig[]> {
    return ocrConfigService.list(opts?.domain);
  },

  async listLlmConfigs(opts?: { domain?: string }): Promise<LLMConfig[]> {
    return llmConfigService.list(opts?.domain);
  },

  toItem,
};
